import dispatcher from "../dispatcher";
import { swipeMachineConstant } from "../constants/constants";
import rq from "../components/utility/rq.js";

export function createSwipeMachine(swipe) {
    rq.post("/api/v1/swipemachine", swipe).then((data) => {
        swipe.swipeId = data[0].lastId;
        dispatcher.dispatch({ type: swipeMachineConstant.SWIPEMACHINE_CREATED, swipe, msg: `swipe  created successfully.` });
    }).catch((data) => {
        dispatcher.dispatch({ type: swipeMachineConstant.SWIPEMACHINE_CREATION_FAILED, msg: `creating swipe failed ! ${data.responseText}` });
    });
}

export function fetchAllSwipes() {
    rq.getJsonData("/api/v1/swipemachines").then((data) => {
        dispatcher.dispatch({ type: swipeMachineConstant.FETCHED_ALL_SWIPEMACHINE, data });
    }).catch((data) => {
        dispatcher.dispatch({ type: swipeMachineConstant.SWIPEMACHINE_FETCH_FAILED, msg: `Fething swipe Machine failed ! ${data.responseText}` });
    });
}


// WEBPACK FOOTER //
// ./src/jsx/actions/swipe-machine-action.jsx